import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HotelComponent } from './hotel.component';
import { HotelResumeModule } from '../hotel-resume/hotel-resume.module';
import { UIModule } from '../../../ui/ui.module';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule,
        HotelResumeModule,
        PermissionModule,
        UIModule,
    ],
    exports: [
        HotelComponent,
    ],
    declarations: [
        HotelComponent,
    ]
})
export class HotelModule { }
